import styled from 'styled-components';

export const DropdownSection = styled.div`
	margin-bottom: 12px;

	&:last-child {
		margin-bottom: 0;
	}
`;

export const SectionDivider = styled.div`
	height: 1px;
	background: ${({ theme }) => theme.gray[200]};
	margin-bottom: 12px;
`;

export const ChangeLink = styled.button`
	background: none;
	border: none;
	color: ${({ theme }) => theme.gray[1000]};
	font-size: 12px;
	font-weight: 500;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	padding: 8px 12px;
	border-radius: 6px;
	transition: background 0.2s;
	width: 100%;
	text-align: left;
	font-family: inherit;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const ChangeLinkText = styled.span`
	flex: 1;
`;

export const ChangeLinkArrow = styled.div`
	display: flex;
	align-items: center;
	color: ${({ theme }) => theme.gray[400]};
	flex-shrink: 0;
	font-size: 12px;
`;
